// extracted by mini-css-extract-plugin
export default {"prices":"price_prices__LNQhh","title":"price_title__U5+Yv","subtitle":"price_subtitle__F0Kap","table":"price_table__dkGnh","text":"price_text__NaLjA"};